import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

type Props = {
  title: string;
  subtitle?: string;
  left?: ReactNode;
  right?: ReactNode;
  className?: string;
};

export function MobileHeader({ title, subtitle, left, right, className }: Props) {
  return (
    <header
      className={cn(
        "mobile-header sticky top-0 z-20 flex shrink-0 items-center gap-2 border-b border-[var(--mail-border)] bg-[var(--mail-surface)] px-3 pb-3",
        className
      )}
    >
      <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
        {left ? <div className="shrink-0">{left}</div> : null}
        <div className="min-w-0 flex-1 overflow-hidden">
          <h1 className="truncate text-base font-semibold leading-tight">{title}</h1>
          {subtitle ? (
            <p className="truncate text-xs text-[var(--mail-muted)]">{subtitle}</p>
          ) : null}
        </div>
      </div>
      {right ? <div className="flex shrink-0 items-center gap-1">{right}</div> : null}
    </header>
  );
}
